import React,{ Component } from "react";
import { connect } from "react-redux";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import UrlFilterForm from "../UrlFilterForm/UrlFilterForm";
import Proptypes from "prop-types";
import {updateUrlFilterPolicy} from "../../../actions/actionFilters";

class UpdateUrlFilter extends Component{
    render(){
        return (
            <div>
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Web Filter Policy</strong>
                                </CardHeader>
                                <UrlFilterForm
                                    updateUrlFilterPolicy={this.props.updateUrlFilterPolicy}
                                    filterPolicyId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateUrlFilter.propTypes = {
    updateUrlFilterPolicy: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
        filters: state.filter.filters || [],
        categories: state.filter.categories || {}
    }),
    dispatch => ({
        updateUrlFilterPolicy: (data) => dispatch(updateUrlFilterPolicy(data))
    }))(UpdateUrlFilter);